import React from 'react';
import PropTypes from 'prop-types';
// import './InitialeCircle.css';

const InitialeCircle = ({ name }) => {
    const getInitials = (name) => {
        const initials = name.split(' ').map(word => word[0]).join('');
        return initials.toUpperCase();
    };

    return (
        <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#d1d5db',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#ffffff',
            fontSize: '14px'
        }}>
            {getInitials(name)}
        </div>
    );
};

InitialeCircle.propTypes = {
    name: PropTypes.string.isRequired,
};

export default InitialeCircle;